<template>
  <div>

    <!-- View measure modal template -->
    <b-modal ref="view-tp"
             hide-footer
             size="xl"
             @hide="hideTPModal"
    >
      <div class="d-block text-center">
        <h4 qid="view-tp-title" v-if="object && object.measure" class="mb-4">
          {{ $t('maintenance.measures.view.title') }}
        </h4>
      </div>

      <div class="row">
        <div :class="{'col-sm-6': object.who_am_i != 'App\\GenericControl\\Models\\GenericControlMeasure', 'col-sm-12': object.who_am_i == 'App\\GenericControl\\Models\\GenericControlMeasure'}">
          <div class="card processing_type">
            <div class="row no-gutters">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <p class="mt-2">{{ $t('maintenance.measures.create.name_label') }}</p>
                  <br>
                  <p>{{ $t('maintenance.measures.create.category_label') }}</p>
                  <br>
                  <p>{{ $t('maintenance.measures.create.description_label') }}</p>
                  <br>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">

                  <div v-if="object && object.measure">
                    <p class="mt-2 text-normal">
                      <span>
                        {{ object.measure.name }}
                      </span>
                    </p>
                    <br>
                    <p class="text-normal">
                      <span v-if="object.measure.measure_category">
                        {{ object.measure.measure_category.name }}
                      </span>
                    </p>
                    <br>
                    <p class="text-normal">
                      <span class="text-formatted">
                        {{ object.measure.description }}
                      </span>
                    </p>
                    <br>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6" v-if="object.who_am_i != 'App\\GenericControl\\Models\\GenericControlMeasure'">
          <div class="card processing_type">
            <div class="row no-gutters" style="min-height: 200px;" v-if="object && object.measure">
              <div class="col-sm-4 card-menu">
                <div class="card-body text-dark">
                  <p class="mt-2">{{ $t('maintenance.measures.create.value_label') }}
                    ({{ object.measure.value }})
                  </p>
                  <br>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="card-body">

                  <div v-if="object">
                    <p class="mt-2 text-normal">
                      <span>
                        <span v-if="object.measure.value == 'date'">{{ object.response  | formatDate }}</span>
                        <span v-if="object.measure.value == 'number'">{{ getNumberValue(object.response) }} {{ object.measure.currency }}</span>
                        <span v-if="object.measure.value == 'dropdown'">{{ object.response }}</span>
                      </span>
                    </p>
                    <br>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6" v-if="(object.measure && object.measure.media && object.measure.media.length) || (object.measure && object.measure.links && object.measure.links.length)">
          <div class="mt-3" v-if="object.measure && object.measure.media && object.measure.media.length">
            <p class="text-dark">{{ $t('attachments.label') }}</p>
            <p v-for="(file, index) in object.measure.media">
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-tp-media-item">
                {{ file.file_name }}
              </a>
            </p>
            <br>
          </div>

          <div v-if="object.measure && object.measure.links && object.measure.links.length">
            <p class="text-dark">{{ $t('links.label') }}</p>
            <div v-if="object.measure.links">
              <p v-for="(link, index) in object.measure.links" >
                <a :href="link.url" target="_blank" qid="create-tp-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
            <br>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="text-center mt-3 card-body">
            <span class="cursor-pointer"
                  @click="controlsShow = !controlsShow"
                  qid="expand-processing-type-validations"
            >
              <span class="mr-2">
                {{ $t('maintenance.measures.associated_control_expand') }}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!controlsShow"/>
              <font-awesome-icon icon="chevron-up" v-if="controlsShow"/>
            </span>
          </div>
          <div v-show="controlsShow">

            <b-tabs>
              <b-tab :title="$t('maintenance.measures.tab.generic_controls')" active>
                <table class="table table-responsive-md mt-3">
                  <thead>
                  <tr>
                    <th scope="col">
                      {{ $t('activities.table.name') }}
                    </th>
                    <th scope="col">
                      {{ $t('system.last_updated') }}
                    </th>
                    <th scope="col">
                      {{ $t('maintenance.measures.latest_status_label') }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in sTableItems"
                        :id="'table-row-' + index"
                    >
                      <td>
                        <router-link
                            :to="{ name: 'generic_controls.view', params: { slug: item.generic_control.slug }}"
                            qid="s-view-page-link"
                        >
                          {{ item.generic_control.name }}
                        </router-link>
                      </td>
                      <td>
                        <span>
                          <Avatar :object="item.updated_by" size="xs" class="mr-2" v-if="item.updated_by"></Avatar>
                          {{ item.updated_at | formatDate }}
                        </span>
                      </td>
                      <td>
                        <span v-if="item.generic_control.last_performed_all">
                          <ControlResultBadge v-if="['completed', 'deviations', 'not_performed', 'not_applicable', 'pass', 'fail'].includes(item.generic_control.last_performed_all.completion_status)" :value="item.generic_control.last_performed_all.completion_status"></ControlResultBadge>
                          <span v-else>
                            <font-awesome-icon
                                    icon="exclamation-triangle"
                                    class="risk-0"
                            />
                            {{ $t('system.not_performed')}}
                          </span>
                        </span>
                        <span v-else>
                          <font-awesome-icon
                                  icon="exclamation-triangle"
                                  class="risk-0"
                          />
                          {{ $t('system.not_performed')}}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="!sLoading && !sTableItems.length" qid="no-results-row" class="text-center">
                      <td colspan="10">
                        <h5 class="mt-3">
                          {{ $t('system.no_results') }}
                        </h5>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-tab>
            </b-tabs>

          </div>
        </div>

      </div>


      <div class="text-right mt-4">
        <b-button class=""
                  variant="success"
                  @click="hideTPModal"
                  qid="create-p-cancel-button"
        >
          {{ $t('processes.policies.view.close') }}
        </b-button>
      </div>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'ContentMeasureViewModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        inputLink: '',
        loadingItems: false,
        showArticleDescription: false,
        secondaryDO: [],
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
        controlsShow: false,
        sTableItems: [],
        sLoading: true
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      },
      active: {
        type: Boolean
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      getNumberValue(number) {
        let transformed = ''
        if (number) {
          transformed = number.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        }
        return transformed
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showTPModal() {
        this.$refs['view-tp'].show()
        this.loadGenericControls()
      },
      hideTPModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.showInput = false;
        this.$emit('closeViewModal');
        this.$refs['view-tp'].hide()
      },
      loadGenericControls() {
        let self = this;
        self.sTableItems = []
        piincHttp.get('measures/' + this.object.measure.slug + '/generic-controls', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.sTableItems = response.data
          self.sLoading = false;
        }, function() {});
      }
    },
    created () {

    }
  }
</script>
